import React from 'react'
import { Box } from '../../../core-components/box'

export const Tick = () => (
  <Box
    as='svg'
    xmlns='http://www.w3.org/2000/svg'
    width='10px'
    height='8px'
    fill='none'
    color='fg/major-on-color'
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M9.678 1.909 3.661 7.55.311 4.41 1.678 2.95l1.983 1.859L8.311.45l1.367 1.459Z'
      clipRule='evenodd'
    />
  </Box>
)
